import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Page from "./Page";
import BookSlider from "../../Components/Common/BookSlider";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import {
  Transaction_Book,
  Transaction_Forum,
} from "../../Connections/Transaction";

import "../../Styles/Blog.css";

const Blog = () => {
  const navigator = useNavigate();
  const [Books, setBooks] = useState([]);

  // =================================================

  useEffect(() => {
    Transaction_Forum.GetHomeForum().then((res) => {
      setBooks(res[2].data.books);
    });
  }, []);
  const handelblog = () => {
    if ("") {
    } else {
      navigator("/");
    }
  };
  // =================================================

  return (
    <Page>
      <MobileNavBar text="بلاگ" action={handelblog} />

      {/* action={() => navigator("/hisstori/home")} */}
      <div className="Blog_wrapper">
        <div
          className="blog-back-icon"
          onClick={() => navigator("/hisstori/home")}
        >
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#ffffff"
            ></path>
          </svg>
        </div>
        <div className="blog-top-img-container">
          <span className="blog-top-title desktop-hidden ">تالار هیس طوری</span>

          <div className="blog-top-img-container-img">
            <img src="/imgs/Blog/Group.png" className="blog-top-img" />
          </div>

          <div className="blog-header-top">
            <span className="blog-header-top-span">تالار هیس طوری</span>
            <span>
              اینجا میتونید آثار تولید شده توسط کاربران دیگه برای هر کتاب را
              ببنید. لایکشون کنید و براشون کامنت بزارید
            </span>
          </div>
          <div className="blog-top-img-container-img">
            <span className="blog-slider-container-span">
              کتاب های هیس طوری
            </span>
          </div>
          <hr className="blog-slider-container-line" />
        </div>
        <div className="blog-slider-container">
          <BookSlider
            slides={Books}
            linkPattern={"/hisstori/blog"}
            isLink={true}
            style={{ height: 215 }}
            breakPoint={{
              1594: {
                slidesPerView: 8,
              },
              1496: {
                slidesPerView: 7,
              },
              1428: {
                slidesPerView: 6,
              },
              1248: {
                slidesPerView: 5,
              },
              1000: {
                slidesPerView: 4,
              },
              842: {
                slidesPerView: 3,
              },
              600: {
                slidesPerView: 2,
              },
            }}
          />
          {/* <BookSlider
            slides={Books}
            isLink={true}
            linkPattern={"/hisstori/blog"}
            breakPoint={{
              1440: {
                slidesPerView: 8,
              },
              1428: {
                slidesPerView: 7,
              },
              1300: {
                slidesPerView: 7,
              },
              1200: {
                slidesPerView: 6,
              },
              1000: {
                slidesPerView: 5,
              },
              992: {
                slidesPerView: 5,
              },
              800: {
                slidesPerView: 4,
              },
              768: {
                slidesPerView: 3,
              },
              600: {
                slidesPerView: 2,
              },
              300: {
                slidesPerView: 2,
              },
              200: {
                slidesPerView: 2,
              },
            }}
          /> */}
        </div>
        <div className="blog-slider-container-mobile">
          {Books.map((book) => (
            <Link
              to={`/hisstori/blog/${book.id}`}
              className="blog-imagebook-slider-container"
              key={book.id}
            >
              <div className="blog-imagebook-slider-innercontainer">
                <img src={book.pic} className="blog-imagebook-slider" />
              </div>
              <span className="blog-book-name">{book.title}</span>
            </Link>
          ))}
          <hr className="blog-slider-container-line" />
        </div>
        <div className="blog-talar-container">
          {/* <div className="blog-talar-container-firtchild">
            <span className="blog-talar-container-text">تالار کتابنو</span>
            <Link
              to={"/hisstori/blog/introduce"}
              className="blog-talar-container-introduce"
            >
              <img src="/imgs/Blog/moarefiKetab.svg" />
              <span>معرفی کتابنو</span>
            </Link>
          </div> */}
          <div className="blog-talar-container-firtchild">
            <Link
              to="/hisstori/blog/Keta-blog"
              state={{ from: "blog" }}
              className="blog-talar-container-subchild"
            >
              <img src="/imgs/Blog/ketablog.svg" />
              <span>کتابلاگ</span>
            </Link>
            <Link
              to={"/hisstori/blog/introduce"}
              className="blog-talar-container-subchild"
            >
              <img src="/imgs/Blog/moarefiKetab.svg" />
              {/* <Link
                to="/hisstori/blog/free-discussion"
                state={{ from: "blog" }}
                className="blog-talar-container-subchild"
              > */}
              {/* <img src="/imgs/Blog/goftgo.svg" /> */}
              <span>معرفی کتابنو</span>
            </Link>
            <Link
              to={"/hisstori/blog/news"}
              state={{ from: "blog" }}
              className="blog-talar-container-subchild"
            >
              <img src="/imgs/Blog/news.svg" />
              <span>اخبار</span>
            </Link>
            <Link
              to={"/hisstori/blog/alerts"}
              state={{ from: "blog" }}
              className="blog-talar-container-subchild"
            >
              <img src="/imgs/Blog/etalayieh.svg" />
              <span>اطلاعیه ها</span>
            </Link>
          </div>
          <div className="blog-talar-container-firtchild">
            <Link
              to={"/hisstori/blog/faq"}
              state={{ from: "blog" }}
              className="blog-talar-container-subchild"
            >
              <img src="/imgs/Blog/question.svg" />
              <span>سوال های پرتکرار</span>
            </Link>
            <Link
              to={"/hisstori/blog/guide"}
              state={{ from: "blog" }}
              className="blog-talar-container-subchild"
            >
              <img src="/imgs/Blog/guid.svg" />
              <span>راهنما</span>
            </Link>
            <Link
              to={"/hisstori/blog/term-of-use"}
              state={{ from: "blog" }}
              className="blog-talar-container-subchild"
            >
              <img src="/imgs/Blog/sharayet.svg" />
              <span>شرایط استفاده</span>
            </Link>
            <Link
              to={"/hisstori/blog/term-and-conditions"}
              state={{ from: "blog" }}
              className="blog-talar-container-subchild"
            >
              <img src="/imgs/Blog/roles.svg" />
              <span>قوانین و مقررات</span>
            </Link>
          </div>
        </div>

        <div className="blog-talar-container-mobile">
          <div className="blog-border-top desktop-hidden"></div>
          <span className="blog-talar-container-mobile-span mobile-hidden ">
            تالار کتابنو
          </span>
          <div className="blog-talar-container-mobile-child">
            <div
              to="/hisstori/blog/Keta-blog"
              state={{ from: "blog" }}
              onClick={() =>
                navigator("/hisstori/blog/keta-blog", {
                  state: {
                    prevPath: `/hisstori/blog`,
                  },
                })
              }
              className="blog-talar-container-mobile-subChild subChild-res"
            >
              <img src="/imgs/Blog/ketablog.svg" />
              <span>کتابلاگ</span>
            </div>
            {/* <Link
              to="/hisstori/blog/free-discussion"
              state={{ from: "blog" }}
              className="blog-talar-container-mobile-subChild"
            >
              <img src="/imgs/Blog/goftgo.svg" />
              <span>گفتگوی آزاد</span>
            </Link> */}
            <Link
              to="/hisstori/blog/faq"
              state={{ from: "blog" }}
              className="blog-talar-container-mobile-subChild"
            >
              <img src="/imgs/Blog/question.svg" />
              <span>سوال های پرتکرار</span>
            </Link>
            <Link
              to="/hisstori/blog/guide"
              state={{ from: "blog" }}
              className="blog-talar-container-mobile-subChild"
            >
              <img src="/imgs/Blog/guid.svg" />
              <span>راهنما</span>
            </Link>
            <Link
              className="blog-talar-container-mobile-subChild"
              style={{ width: "100%" }}
              to="/hisstori/blog/introduce"
              state={{ from: "blog" }}
            >
              <img src="/imgs/Blog/moarefiKetab.svg" />
              <span>معرفی کتابنو</span>
            </Link>
            <Link
              to="/hisstori/blog/news"
              state={{ from: "blog" }}
              className="blog-talar-container-mobile-subChild"
            >
              <img src="/imgs/Blog/news.svg" />
              <span>اخبار</span>
            </Link>
            <Link
              className="blog-talar-container-mobile-subChild"
              to="/hisstori/blog/alerts"
              state={{ from: "blog" }}
            >
              <img src="/imgs/Blog/etalayieh.svg" />
              <span>اطلاعیه ها</span>
            </Link>
            <Link
              to="/hisstori/blog/term-of-use"
              state={{ from: "blog" }}
              className="blog-talar-container-mobile-subChild"
            >
              <img src="/imgs/Blog/sharayet.svg" />
              <span>شرایط استفاده</span>
            </Link>
            <Link
              to="/hisstori/blog/term-and-conditions"
              state={{ from: "blog" }}
              className="blog-talar-container-mobile-subChild"
            >
              <img src="/imgs/Blog/roles.svg" />
              <span>قوانین و مقررات</span>
            </Link>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Blog;
